import type { FunctionComponent } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import navigationFooterLabels from '../../utils/navigationFooterLabels';
import Layout from '../layout/Layout';
import headerDesktopSVG from '../../assets/images/welcome-header.svg';
import * as styles from './Welcome.module.css';

type WelcomeProps = {
  onClick: () => void;
  intro: string;
};

const Welcome: FunctionComponent<WelcomeProps> = ({ onClick, intro }) => {
  const onNextButtonClick = () => {
    datadogRum.addAction('Begin Personal Survey');
    onClick();
  };
  const nextButton = {
    label: navigationFooterLabels.LETS_BEGIN,
    onClick: onNextButtonClick,
  };

  return (
    <Layout nextButton={nextButton}>
      <div className={styles.welcomeContainer} data-testid="welcome-container">
        <img className={styles.headerImage} src={headerDesktopSVG} alt="" />
        <h1 className={styles.title}>Personal Survey</h1>
        <p className={styles.intro}>{intro}</p>
      </div>
    </Layout>
  );
};

Welcome.displayName = 'Welcome';

export default Welcome;
